<div class="container">
  <h4>Manage Test Environment</h4>
  @if (this.service.currentUser.isTestingEnabled === true) {
    <div>
      <mat-form-field class="col-12" style="padding: 0px;">
        <mat-label>Market</mat-label>
        <mat-select>
          @for (market of markets; track market) {
            <mat-option [value]="market.id" (click)="OnChangeMarket(market.id)">
            {{market.value}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (isSelectedMarket) {
        <div class="col-12" [@slider]="isSelectedMarket? 'show' : null" class="slider">
          <mat-checkbox color="primary" [(ngModel)]="selectedTestMarket.enabled">Enabled</mat-checkbox>
          <div class="col-12" style="padding-left: 0px; padding-right: 0px;">
            <mat-form-field class="col-6" style="padding-left: 0px;">
              <mat-label>Contribute Range Min</mat-label>
              <input type="number" matInput [(ngModel)]="selectedTestMarket.contributorRangeMin"
                [ngModelOptions]="{standalone: true}">
              </mat-form-field>
              <mat-form-field class="col-6" style="padding-right: 0px;">
                <mat-label>Contribute Range Max</mat-label>
                <input type="number" matInput [(ngModel)]="selectedTestMarket.contributorRangeMax"
                  [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </div>
              @for (instrument of selectedTestMarket.instruments; track instrument) {
                <div class="row">
                  <div class="col-4">
                    <mat-label>{{instrument.instrumentName}}</mat-label>
                  </div>
                  <div class="col-8" style="display: flex;">
                    <div class="{{instrument.hasVolume === true ? 'col-6' : 'col-12'}}">
                      <div class="col-12">
                        <mat-form-field class="col-6" style="padding-left: 0px;">
                          <mat-label>Rate Min</mat-label>
                          <input type="number" matInput [(ngModel)]="instrument.rateMin"
                            [ngModelOptions]="{standalone: true}">
                          </mat-form-field>
                          <mat-form-field class="col-6" style="padding-right: 0px;">
                            <mat-label>Rate Max</mat-label>
                            <input type="number" matInput [(ngModel)]="instrument.rateMax"
                              [ngModelOptions]="{standalone: true}">
                            </mat-form-field>
                          </div>
                        </div>
                        @if (instrument.hasVolume === true) {
                          <div class="col-6">
                            <div class="col-12">
                              <mat-form-field class="col-6" style="padding-left: 0px;">
                                <mat-label>Volume Min</mat-label>
                                <input type="number" matInput [(ngModel)]="instrument.volumeMin"
                                  [ngModelOptions]="{standalone: true}">
                                </mat-form-field>
                                <mat-form-field class="col-6" style="padding-right: 0px;">
                                  <mat-label>Volume Max</mat-label>
                                  <input type="number" matInput [(ngModel)]="instrument.volumeMax"
                                    [ngModelOptions]="{standalone: true}">
                                  </mat-form-field>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      }
                      <div class="col-12">
                        <button mat-raised-button color="warn" type="button" (click)="OnClickReset()">RESET</button>&nbsp;
                        <button mat-raised-button color="primary" type="button" (click)="OnClickSave()">SAVE</button>
                      </div>
                    </div>
                  }
                </div>
              }

              @if (this.service.currentUser.isTestingEnabled === false) {
                <div>
                  Testing mode is disabled in the configuration.
                </div>
              }
            </div>